import { postEventReport } from '../api/report';
import { IEventData } from '../types';
import {
  generateEventUUID,
  getCommonParams,
  getTrackUserInfo,
  ITrack,
  IWaitAuthDataEvent,
} from './util';

export const packPayload = (
  event_name: string,
  page: string,
  event_data: Record<string, unknown> = {},
  common_params: Record<string, unknown> = {}
) => {
  const commonParams = getCommonParams();
  const eventData = {
    common_params: {
      ...commonParams,
      ...(common_params || {}),
      event_name,
      page,
      // language: getLanguage(),
    },
    ...event_data,
  };
  const userInfo = getTrackUserInfo();

  const payload = {
    event_uuid: generateEventUUID(),
    event_data: JSON.stringify(eventData),
    event_timestamp_ms: commonParams.event_time,
    user_identifier: String(userInfo.user_id || userInfo.uuid), // uuid or user_id
  };

  return payload;
};

export class TalkieTrack implements ITrack {
  asyncEventQueue: IEventData[];
  authReadyEventQueue: IWaitAuthDataEvent[];

  reportGap: number;
  reportTimer: NodeJS.Timeout | null;

  lastReportTime: number;

  constructor() {
    this.asyncEventQueue = []; // 异步上报队列
    this.authReadyEventQueue = []; // 等待 authData 数据事件队列

    this.reportGap = 300; // report every 300ms
    this.reportTimer = null;
    this.lastReportTime = new Date().getTime();
  }

  // send immediately
  async send(
    event_name: string,
    page: string,
    event_data: Record<string, unknown> = {},
    common_params: Record<string, unknown> = {}
  ) {
    const payload = packPayload(event_name, page, event_data, common_params);

    await this.report(payload);
  }

  // send async
  collect(
    event_name: string,
    page: string,
    event_data: Record<string, unknown> = {},
    common_params: Record<string, unknown> = {}
  ) {
    const payload = packPayload(event_name, page, event_data, common_params);
    this.asyncEventQueue.push(payload);

    if (!this.reportTimer) {
      this.reportTimer = setTimeout(() => {
        this.report();
        this.lastReportTime = new Date().getTime();

        this.reportTimer = null;
      }, this.reportGap);
    }
  }

  async report(payload?: IEventData) {
    try {
      if (payload) {
        await postEventReport({ events: [payload] });
      } else if (this.asyncEventQueue.length) {
        const events = [...this.asyncEventQueue];
        this.asyncEventQueue.length = 0;
        await postEventReport({ events });
      }
    } catch (err) {
      console.error('report error', err);
    }
  }
}
